import { useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  Typography,
} from "@mui/material";

import {
  FaBuilding,
  FaClock,
  FaEnvelope,
  FaMagic,
  FaPhoneAlt,
  FaTag,
  FaTruck,
  FaTshirt,
} from "react-icons/fa";

import {
  FaCheckCircle,
  FaChevronRight
} from "react-icons/fa";
import faqBg from "../../assets/images/faq_bg.png";
import faqBgM from "../../assets/images/faq_bg_m.png";
import faqs_h_b from "../../assets/images/faqs_h_b.png";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";
// import faqCardBg from "../../assets/images/bg_6.png";
import faqCardBg from "../../assets/images/faq_card_bg.png";

const faqs = [
  {
    icon: <FaTruck />,
    q: "Do you offer pickup and delivery services?",
    a: "Yes, we offer convenient pickup and delivery services for eligible orders, making professional care easy and hassle-free.",
  },

  {
    icon: <FaClock />,
    q: "Do you offer same-day or express service?",
    a: "Yes. Same-day and express services are available for select cleaning, alteration and repair requests.",
  },

  {
    icon: <FaTshirt />,
    q: "What services does Comet Cleaners provide?",
    a: "We offer dry cleaning, laundry, alterations, shoe cleaning & repair, wedding dress care, custom printing, rug cleaning, handbag cleaning, comforter cleaning, cushion cleaning and steam pressing services.",
  },

  {
    icon: <FaMagic />,
    q: "Can you remove tough stains?",
    a: "Our experienced team uses professional cleaning techniques and specialized treatments to safely remove many difficult stains and restore your items.",
  },

  {
    icon: <FaTag />,
    q: "How are prices calculated?",
    a: "Pricing varies based on the service, item type, material and treatment required. We provide transparent pricing with no hidden fees.",
  },

  {
    icon: <FaBuilding />,
    q: "Do you offer commercial or business services?",
    a: "Yes. We provide cleaning, garment care and custom printing solutions for businesses, organizations, schools, teams and corporate clients.",
  },

  {
    icon: <FaTshirt />,
    q: "Do you clean wedding dresses and delicate items?",
    a: "Yes. We specialize in wedding dresses, formal wear, designer garments and delicate fabrics that require professional care.",
  },

  {
    icon: <FaMagic />,
    q: "Do you repair shoes, handbags and other specialty items?",
    a: "Yes. We provide shoe cleaning, shoe repair, sneaker restoration, handbag cleaning and other specialty care services designed to extend the life of your favorite items.",
  },
];

function FAQSection() {
  const [expanded, setExpanded] = useState(0);

  return (
    <Box
      sx={{
        py: {
          xs: 4,
          md: 6,
        },

        position: "relative",

        overflow: "hidden",

        backgroundImage: {
          xs: `url(${faqBgM})`,
          md: `url(${faqBg})`,
        },

        backgroundSize: "cover",

        backgroundPosition: "center",
      }}
    >
      {/* BACKGROUND QUESTION MARKS */}

      <Typography
        sx={{
          position: "absolute",
          top: 50,
          left: "35%",

          fontSize: {
            xs: "100px",
            md: "180px",
          },

          fontWeight: 900,

          color: "rgba(0,87,255,.05)",

          pointerEvents: "none",
        }}
      >
        ?
      </Typography>

      <Typography
        sx={{
          position: "absolute",

          right: 40,

          top: 120,

          fontSize: {
            xs: "90px",
            md: "160px",
          },

          fontWeight: 900,

          color: "rgba(0,87,255,.05)",

          pointerEvents: "none",
        }}
      >
        ?
      </Typography>

      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",

            flexWrap: "wrap",

            justifyContent: "space-between",

            gap: {
              xs: 5,
              lg: 8,
            },
          }}
        >
          {/* LEFT SIDE */}

          <Box
            sx={{
              width: {
                xs: "100%",
                lg: "38%",
              },
            }}
          >
            <Box
              sx={{
                display: "inline-flex",

                alignItems: "center",

                gap: 1,

                px: 2.5,

                py: 1,

                borderRadius: "999px",

                background: "rgba(255,255,255,.78)",

                backdropFilter: "blur(18px)",

                border: "1px solid rgba(0,87,255,.08)",

                boxShadow: "0 10px 30px rgba(0,87,255,.08)",

                color: "#0057FF",

                fontWeight: 700,

                fontSize: {
                  xs: "8px",
                  md: "10px",
                },

                letterSpacing: "1px",

                textTransform: "uppercase",
              }}
            >
              ✦ FREQUENTLY ASKED QUESTIONS
            </Box>
            {/* <Box
              sx={{
                display: "inline-flex",

                alignItems: "center",

                gap: 1,

                px: 2.5,

                py: 1,

                borderRadius: "999px",

                background: "rgba(255,255,255,.78)",

                backdropFilter: "blur(18px)",

                border: "1px solid rgba(0,87,255,.08)",

                boxShadow: "0 10px 30px rgba(0,87,255,.08)",

                color: "#0057FF",

                fontWeight: 700,

                fontSize: {
                  xs: "8px",
                  md: "10px",
                },

                letterSpacing: "1px",

                textTransform: "uppercase",
              }}
            >
              <Box
                sx={{
                  width: 34,

                  height: 34,

                  borderRadius: "50%",

                  background: "linear-gradient(135deg,#0057FF,#4AA3FF)",

                  color: "#fff",

                  display: "flex",

                  alignItems: "center",

                  justifyContent: "center",
                }}
              >
                ?
              </Box>

              <Typography
                sx={{
                  color: "#0057FF",

                  fontWeight: 800,

                  letterSpacing: "1px",
                  fontSize: {
                    xs: "8px",
                    md: "10px",
                  },
                }}
              >
                FREQUENTLY ASKED QUESTIONS
              </Typography>
            </Box> */}
            <Typography
              sx={{
                mt: 2,

                fontWeight: 900,

                lineHeight: 1.05,

                letterSpacing: "-1px",

                fontSize: {
                  xs: "38px",
                  sm: "46px",
                  md: "56px",
                  lg: "56px",
                },
              }}
            >
              <Box
                component="span"
                sx={{
                  display: "block",

                  color: "#07122F",
                }}
              >
                Everything You
              </Box>

              <Box
                component="span"
                sx={{
                  display: "block",

                  background: "linear-gradient(135deg,#0057FF,#4AA3FF)",

                  WebkitBackgroundClip: "text",

                  WebkitTextFillColor: "transparent",
                }}
              >
                Need To Know
              </Box>
            </Typography>{" "}
            <Typography
              sx={{
                mt: 2,

                // maxWidth: "540px",

                color: "#64748b",

                lineHeight: 1.9,

                fontSize: {
                  xs: "14px",
                  md: "16px",
                },
              }}
            >
              "Find answers about our cleaning, alterations, shoe repair, custom
              printing, wedding dress care, pickup & delivery, pricing and
              specialty care services."
            </Typography>
            <Box
              sx={{
                mt: 1,
                display: "flex",

                alignItems: "center",

                justifyContent: {
                  xs: "center",
                  lg: "flex-start",
                },

                gap: 2,
              }}
            >
              <Box
                sx={{
                  width: 120,
                  height: 2,
                  bgcolor: "rgba(0,87,255,.15)",
                }}
              />

              <Typography
                sx={{
                  color: "#0057FF",
                  fontSize: "30px",
                }}
              >
                ✦
              </Typography>

              <Box
                sx={{
                  width: 120,
                  height: 2,
                  bgcolor: "rgba(0,87,255,.15)",
                }}
              />
            </Box>
            {/* HELP CARD */}
            <Box
              sx={{
                mt: 4,

                p: {
                  xs: 2,
                  md: 2.2,
                },

                maxWidth: "460px",

                borderRadius: "24px",

                background:
                  "linear-gradient(180deg,rgba(255,255,255,.82),rgba(246,249,255,.72))",

                backdropFilter: "blur(20px)",

                border: "1px solid rgba(255,255,255,.95)",

                boxShadow:
                  "0 15px 40px rgba(0,87,255,.08), inset 0 1px 0 rgba(255,255,255,.9)",

                position: "relative",

                overflow: "hidden",
                backgroundImage: `
// linear-gradient(
// rgba(255,255,255,.90),
// rgba(248,251,255,.85)
// ),
url(${faqs_h_b})
`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                // minWidth:"440px"
              }}
            >
              {/* LEFT BLUE LINE */}

              <Box
                sx={{
                  position: "absolute",

                  left: 10,

                  top: 18,

                  bottom: 18,

                  width: "3px",

                  borderRadius: "20px",

                  background: "linear-gradient(180deg,#0057FF,#4AA3FF)",
                }}
              />

              <Box
                sx={{
                  display: "flex",

                  flexDirection: {
                    xs: "column",
                    md: "row",
                  },

                  alignItems: "center",

                  gap: 2.5,
                }}
              >
                {/* SUPPORT ICON */}

                <Box
                  sx={{
                    position: "relative",

                    width: {
                      xs: 80,
                      md: 95,
                    },

                    height: {
                      xs: 80,
                      md: 95,
                    },

                    flexShrink: 0,
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",

                      inset: 0,

                      borderRadius: "50%",

                      background: "rgba(0,87,255,.08)",
                    }}
                  />

                  <Box
                    sx={{
                      position: "absolute",

                      inset: 8,

                      borderRadius: "50%",

                      border: "2px solid rgba(0,87,255,.08)",
                    }}
                  />

                  <Box
                    sx={{
                      position: "absolute",

                      inset: 16,

                      borderRadius: "50%",

                      background: "linear-gradient(135deg,#0057FF,#4AA3FF)",

                      color: "#fff",

                      display: "flex",

                      alignItems: "center",

                      justifyContent: "center",

                      boxShadow: "0 12px 30px rgba(0,87,255,.25)",
                    }}
                  >
                    <SupportAgentRoundedIcon
                      sx={{
                        fontSize: {
                          xs: 28,
                          md: 34,
                        },
                      }}
                    />
                  </Box>
                </Box>

                {/* CONTENT */}

                <Box sx={{ flex: 1, width: "100%" }}>
                  <Typography
                    sx={{
                      fontWeight: 900,

                      color: "#07122F",

                      textAlign: {
                        xs: "center",
                        md: "left",
                      },

                      fontSize: {
                        xs: "22px",
                        md: "28px",
                      },
                    }}
                  >
                    Need More Help?
                  </Typography>

                  <Typography
                    sx={{
                      color: "#6B7280",

                      mb: 2,

                      mt: 0.3,

                      textAlign: {
                        xs: "center",
                        md: "left",
                      },

                      fontSize: "13px",
                    }}
                  >
                    Our support team is here for you
                  </Typography>

                  {/* CALL CARD */}

                  <Box
                    sx={{
                      p: 1.1,

                      mb: 1.2,

                      borderRadius: "14px",

                      background: "rgba(255,255,255,.55)",

                      border: "1px solid rgba(255,255,255,.9)",

                      display: "flex",

                      alignItems: "center",

                      justifyContent: "space-between",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",

                        alignItems: "center",

                        gap: 1.2,
                      }}
                    >
                      <Box
                        sx={{
                          width: 38,

                          height: 38,

                          borderRadius: "10px",

                          background: "linear-gradient(135deg,#0057FF,#4AA3FF)",

                          display: "flex",

                          alignItems: "center",

                          justifyContent: "center",

                          color: "#fff",
                        }}
                      >
                        <PhoneRoundedIcon
                          sx={{
                            fontSize: 18,
                          }}
                        />
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontWeight: 700,

                            color: "#07122F",

                            fontSize: "14px",
                          }}
                        >
                          Call Us
                        </Typography>

                        <Typography
                          sx={{
                            color: "#64748B",

                            fontSize: "12px",
                          }}
                        >
                          +1 (234) 567-890
                        </Typography>
                      </Box>
                    </Box>

                    <ChevronRightRoundedIcon
                      sx={{
                        color: "#7EA9FF",

                        fontSize: 22,
                      }}
                    />
                  </Box>

                  {/* EMAIL CARD */}

                  <Box
                    sx={{
                      p: 1.1,

                      borderRadius: "14px",

                      background: "rgba(255,255,255,.55)",

                      border: "1px solid rgba(255,255,255,.9)",

                      display: "flex",

                      alignItems: "center",

                      justifyContent: "space-between",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",

                        alignItems: "center",

                        gap: 1.2,
                      }}
                    >
                      <Box
                        sx={{
                          width: 38,

                          height: 38,

                          borderRadius: "10px",

                          background: "linear-gradient(135deg,#0057FF,#4AA3FF)",

                          display: "flex",

                          alignItems: "center",

                          justifyContent: "center",

                          color: "#fff",
                        }}
                      >
                        <EmailRoundedIcon
                          sx={{
                            fontSize: 18,
                          }}
                        />
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontWeight: 700,

                            color: "#07122F",

                            fontSize: "14px",
                          }}
                        >
                          Email Support
                        </Typography>

                        <Typography
                          sx={{
                            color: "#64748B",

                            fontSize: "12px",
                          }}
                        >
                          cometcleaners5@gmail.com
                        </Typography>
                      </Box>
                    </Box>

                    <ChevronRightRoundedIcon
                      sx={{
                        color: "#7EA9FF",

                        fontSize: 22,
                      }}
                    />
                  </Box>

                  {/* RESPONSE BADGE */}

                  <Box
                    sx={{
                      mt: 1.5,

                      mx: {
                        xs: "auto",
                        md: 0,
                      },

                      width: "fit-content",

                      px: 2,

                      py: 0.7,

                      borderRadius: "999px",

                      background: "rgba(255,255,255,.75)",

                      border: "1px solid rgba(255,255,255,.9)",

                      display: "flex",

                      alignItems: "center",

                      gap: 1,
                    }}
                  >
                    <VerifiedRoundedIcon
                      sx={{
                        color: "#0057FF",

                        fontSize: 16,
                      }}
                    />

                    <Typography
                      sx={{
                        color: "#0057FF",

                        fontWeight: 700,

                        fontSize: {
                          xs: "11px",
                          md: "12px",
                        },
                      }}
                    >
                      Average Response Time: Under 1 Hour
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>

          {/* RIGHT SIDE */}
          <Box
            sx={{
              width: {
                xs: "100%",
                lg: "48%",
              },
            }}
          >
            {faqs.map((item, index) => (
              <Accordion
                key={index}
                expanded={expanded === index}
                onChange={() => setExpanded(expanded === index ? -1 : index)}
                disableGutters
                elevation={0}
                sx={{
                  mb: 1.2,

                  borderRadius: "18px !important",

                  overflow: "hidden",

                  backgroundImage: `
          // linear-gradient(
          //   rgba(255,255,255,.94),
          //   rgba(248,251,255,.88)
          // ),
          url(${faqCardBg})
        `,

                  backgroundSize: "cover",

                  backgroundPosition: "center",

                  backgroundRepeat: "no-repeat",

                  backdropFilter: "blur(12px)",

                  border: "1px solid rgba(255,255,255,.9)",

                  boxShadow: "0 8px 25px rgba(0,87,255,.05)",

                  transition: ".3s ease",

                  "&:before": {
                    display: "none",
                  },

                  "&:hover": {
                    transform: "translateY(-2px)",

                    boxShadow: "0 15px 35px rgba(0,87,255,.10)",
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={
                    <Box
                      sx={{
                        width: {
                          xs: 36,
                          md: 32,
                        },

                        height: {
                          xs: 36,
                          md: 32,
                        },

                        borderRadius: "50%",

                        background: "#fff",

                        boxShadow: "0 6px 18px rgba(0,87,255,.08)",

                        color: "#0057FF",

                        display: "flex",

                        alignItems: "center",

                        justifyContent: "center",

                        fontSize: {
                          xs: "20px",
                          md: "18px",
                        },

                        fontWeight: 700,
                      }}
                    >
                      {expanded === index ? "−" : "+"}
                    </Box>
                  }
                  sx={{
                    minHeight: {
                      xs: 72,
                      md: 68,
                    },

                    px: {
                      xs: 1.5,
                      md: 1.8,
                    },

                    "& .MuiAccordionSummary-content": {
                      margin: "8px 0",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",

                      alignItems: "center",

                      gap: 1.5,

                      width: "100%",
                    }}
                  >
                    {/* ICON */}

                    <Box
                      sx={{
                        width: {
                          xs: 42,
                          md: 38,
                        },

                        height: {
                          xs: 42,
                          md: 38,
                        },

                        borderRadius: "50%",

                        background: "linear-gradient(135deg,#0057FF,#4AA3FF)",

                        color: "#fff",

                        display: "flex",

                        alignItems: "center",

                        justifyContent: "center",

                        fontSize: {
                          xs: "16px",
                          md: "14px",
                        },

                        flexShrink: 0,

                        boxShadow: "0 8px 20px rgba(0,87,255,.18)",
                      }}
                    >
                      {item.icon}
                    </Box>

                    {/* QUESTION */}

                    <Typography
                      sx={{
                        fontWeight: 800,

                        color: "#07122F",

                        lineHeight: 1.35,

                        fontSize: {
                          xs: "14px",
                          sm: "15px",
                          md: "14px",
                          lg: "15px",
                        },
                      }}
                    >
                      {item.q}
                    </Typography>
                  </Box>
                </AccordionSummary>

                <AccordionDetails
                  sx={{
                    pl: {
                      xs: 2,
                      md: "58px",
                    },

                    pr: 2,

                    pt: 0,

                    pb: 2,
                  }}
                >
                  <Typography
                    sx={{
                      color: "#64748B",

                      fontSize: {
                        xs: "13px",
                        md: "13px",
                      },

                      lineHeight: 1.7,
                    }}
                  >
                    {item.a}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default FAQSection;
